export const MEDICATION = 'MEDICATION';
export const SUPPLEMENT = 'SUPPLEMENT';
export const ACTIVITIES = 'ACTIVITIES';
